import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'
import {
  ACCESSTOKEN,
  COMPANY_ID,
  USER_ID,
} from './../../../constants/local_storage'

function* loadShipmentContract(action) {
    const {
        data: {
          page,
          pageSize,
          orderBy,
          orderType,
          accessToken,
          company_id,
          is_admin,
          is_vendor,
          location_visibility,
          filterObj,
          limit_export,
          type,
          file_value_pdf,
          exactly_location,
          mill_location_list,
          plant_location_list,
          material_visibility,
        },
    } = action.payload

    try {
        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/get-shipping-contract-list`,
            {
              page,
              pageSize,
              orderBy,
              orderType,
              company_id,
              is_admin,
              is_vendor,
              location_visibility,
              filterObj,
              limit_export,
              type,
              file_value_pdf,
              exactly_location,
              mill_location_list,
              plant_location_list,
              material_visibility,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )
        yield put(actions.loadShipmentContract.success(res.data, page, pageSize))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadShipmentContract.failure())
  }
}

function* createShipmentContract(action) {
  const {  
    data: {
      contract_overlaps_id,
      contract_type,
      plant_id,
      mining_id,
      material_id,
      vendor_id,
      weigh_unit,
      weigh_per_trip,
      contract_shipping_rate,
      shipping_rate,
      manpower_rate,
      tons_per_trip,
      distance,
      duration,
      integrated_with,
      start_at,
      expired_at
    },
    cb,
  } = action.payload

  try {  
    const res = yield call(
      axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/create-shipment-contract`,
        {
          contract_overlaps_id,
          contract_type,
          plant_id,
          mining_id,
          material_id,
          vendor_id,
          weigh_unit,
          weigh_per_trip,
          contract_shipping_rate,
          shipping_rate,
          manpower_rate,
          tons_per_trip,
          distance,
          duration,
          integrated_with,
          start_at,
          expired_at
        },
        { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
      cb(res.data)
    yield put(actions.createShipmentContract.success(res.data))
  } catch (err) {
    yield put(actions.createShipmentContract.failure())
  }
}

function* updateShipmentContract(action) {
  const {  
    data: {
      id,
      isupply_plant_mining_contract_config_id,
      contract_overlaps_id,
      contract_type,
      plant_id,
      mining_id,
      material_id,
      vendor_id,
      weigh_unit,
      weigh_per_trip,
      contract_shipping_rate,
      shipping_rate,
      manpower_rate,
      tons_per_trip,
      distance,
      duration,
      integrated_with,
      start_at,
      expired_at
    },
    cb,
  } = action.payload

  try {  
    const res = yield call(
      axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/update-shipment-contract`,
        {
          id,
          isupply_plant_mining_contract_config_id,
          contract_overlaps_id,
          contract_type,
          plant_id,
          mining_id,
          material_id,
          vendor_id,
          weigh_unit,
          weigh_per_trip,
          contract_shipping_rate,
          shipping_rate,
          manpower_rate,
          tons_per_trip,
          distance,
          duration,
          integrated_with,
          start_at,
          expired_at
        },
        { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
      cb(res.data)
    yield put(actions.updateShipmentContract.success(res.data))
  } catch (err) {
    yield put(actions.updateShipmentContract.failure())
  }
}

function* loadShipmentContractDetail(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply/shipment-contract-detail`,
      {
        id: id
      },  
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.loadShipmentContractDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadShipmentContractDetail.failure())
  }
}


export default function* watchShippingContract() {
    yield all([
        takeEvery(
            actions.LOAD_SHIPMENT_CONTRACT.REQUEST,
            loadShipmentContract,
        ),
        takeEvery(
          actions.CREATE_SHIPMENT_CONTRACT.REQUEST,
          createShipmentContract,
        ),
        takeEvery(
          actions.UPDATE_SHIPMENT_CONTRACT.REQUEST,
          updateShipmentContract,
        ),
        takeEvery(
          actions.LOAD_SHIPMENT_CONTRACT_DETAIL.REQUEST,
          loadShipmentContractDetail,
        ),
    ])
}

export {
    loadShipmentContract,
    loadShipmentContractDetail,
    createShipmentContract,
    updateShipmentContract
}